<template>
  <v-container class="px-0 pt-3 pb-5">
    <v-card class="pb-3" outlined width="100%">
        <v-card-text>
            <v-row>
                <v-col class="pt-0 pb-5" cols="12">
                    <h2 class="authorizer-title">
                        
                        <b>Carteiras cadastradas</b>
                    </h2>
                </v-col>
                <v-col class="px-0 py-0" cols="12">
                    <v-row>
                        <v-col class="text-left px-6 py-0" cols="6" sm="12" xs="12">
                            <v-form>
                                 <label>Pesquisar por nome da carteira</label>
                            <v-text-field
                                v-model="search"
                                dense
                                outlined
                                type="text"
                                @keyup="filterList()"
                            ></v-text-field>
                            </v-form>

                        </v-col>
                    </v-row>
                    <v-row class="ma-0" v-for="(item, ind) in filteredList" :key="item.id">
                        <v-col class="text-left px-3 py-0" cols="9">
                            <!-- <v-icon class="mr-2" x-small :color="item.ativa?'success':'error'">{{item.ativa?'fa-check-circle':'fa-ban'}}</v-icon> -->
                            <b>{{item.nome.toUpperCase()}}<br></b>
                            <!-- <small>{{item.operadora_ans_id.length}} operadoras,
                            {{item.prestador_id.length}} prestadores,
                            {{item.owners_ids.length}} analistas</small> -->
                            <span>
                            <v-tooltip bottom open-delay="50">
                                <template v-slot:activator="{ on, attrs }">
                                   <span>{{item.operadoras_ans_ids.length? item.operadoras_ans_ids.length: 'TODAS'}}
                                   <v-icon x-small class="pb-0 ml-0 mr-2" color="primary"  v-bind="attrs" v-on="on">fa-heartbeat</v-icon>
                                   </span>
                                </template>
                                <span class="px-3 py-1 ma-0"
                                style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                                > {{item.operadoras_ans_ids.length>1 || item.operadoras_ans_ids.length==0?'operadoras': 'operadora'}}</span>
                            </v-tooltip>
                            <v-tooltip bottom open-delay="50">
                                <template v-slot:activator="{ on, attrs }">
                                   <span>{{item.prestadores_ids.length? item.prestadores_ids.length: 'TODOS'}}
                                    <v-icon x-small class="pb-1 ml-0 mr-2" color="primary" v-bind="attrs" v-on="on">fa-hospital</v-icon>
                                   </span>
                                </template>
                                <span class="px-3 py-1 ma-0"
                                style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                                > {{item.prestadores_ids.length>1?'prestadores': 'prestador'}}</span>
                            </v-tooltip>
                            <v-tooltip bottom open-delay="50">
                                <template v-slot:activator="{ on, attrs }">
                                   <span>{{item.owners_ids.length? item.owners_ids.length: 'TODOS'}}
                                   <v-icon x-small class="pb-1 ml-0 mr-2" color="primary" v-bind="attrs" v-on="on">fa-users</v-icon>
                                   </span>
                                </template>
                                <span class="px-3 py-1 ma-0"
                                style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                                >{{item.owners_ids.length>1 || item.owners_ids.length==0 ?'analistas': 'analista'}}</span>
                            </v-tooltip>
                            </span>
<!-- fa-user-md -->
                        </v-col>
                        <!-- <v-col class="text-left px-2 py-0" cols="4">
                            Responsável:<br> <b>{{getNomeResponsavel(item.gestor)}}</b>
                        </v-col> -->
                        <v-col class="px-2 py-0 text-right" cols="3">
                            <v-spacer/>
                            <v-btn icon @click="acao(item, 'viewItem')">
                                <v-icon size="14px" color="primary">fa fa-eye</v-icon>
                            </v-btn>
                            <v-btn icon @click="acao(item, 'editItem')">
                                <v-icon size="14px" color="primary">fa fa-pencil-alt</v-icon>
                            </v-btn>
                            <!-- <v-btn icon @click="confirmarBloqueio(item)">
                                <v-icon size="14px" color="primary">{{!item.ativa?'fa-check-circle':'fa-ban'}}</v-icon>
                            </v-btn> -->
                            <v-btn icon @click="confirmarExclusao(item)">
                                <v-icon size="14px" color="primary">fa-trash-alt</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col class="pa-0 py-2" cols="12" v-if="ind < (list.length-1)">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card> 
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
export default {
    data() {
        return {
            filteredList: [],
            search: ''
        }
    },
    mounted() {
        this.filterList()
    },
    methods: {
        confirmarBloqueio(item) {
            let nomeCarteira = item.nome? item.nome.toUpperCase() : ''
            let paramModal = {
                type: "warning",
                title: item.status? "Desativação de carteira?": "Reativação de carteira",
                message: item.status? `Deseja DESATIVAR a carteira ${nomeCarteira}?` : `Deseja REATIVAR a carteira ${nomeCarteira}?`,
                callback: () => {
                    let obj = {
                        id:item.id, 
                    }
                    this.acao(obj, 'toggleStatusItem')
                },
                btConfirm: { name: "Sim", show: true, color: 'warning' },//color: '#D0021B'
                btCancel: { name: 'Não', show: true }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        },
        confirmarExclusao(item) {
            let nomeCarteira = item.nome? item.nome.toUpperCase() : ''
            let paramModal = {
                type: "error",
                title: "Excluir carteira?",
                message: `Deseja excluir a carteira ${nomeCarteira}`,
                callback: () => {
                    let obj = {
                        carteira_id: item.id, 
                    }
                    this.acao(obj, 'delItem')
                },
                btConfirm: { name: "Excluir", show: true, color: 'error' },
                btCancel: { name: 'Cancelar', show: true }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        },
        filterList(){
            let filtered = this.list.filter(el => {
                 let regex = this.search && this.search !='' ? new RegExp(this.search.toUpperCase(), "gi") : null
                 let matchSearch = regex ? el.nome.toUpperCase().match(regex) != null : true
                 if( matchSearch) return el
            })
            this.filteredList = filtered
        },
        getNomeResponsavel(gestor){
           return this.listResponsavel.find(resp=> resp.Id == gestor).Nome
        }
    },
    props: {
        list: Array,
        acao: Function,
        listResponsavel: Array
    }
}
</script>

<style>

</style>